import React from "react";
import * as styles from "./RecipeCard.module.scss";
import Button from "../../../UI/Button/Button";
import WhiteArrowRight from "../../../../icons/arrows/white-right-arrow.svg";

const RecipeCard = ({ recipe, colorCategory }) => {
  const containerStyle = {
    backgroundImage: `linear-gradient(90deg, rgba(46,46,46,0.499124649859944) 0%, rgba(255,255,255,0) 100%), url(${recipe.image})`,
  };
  return (
    <div className={styles.recipeCard__container} style={containerStyle}>
      <div className={styles.recipeCard__content}>
        <div className={styles.recipeCard__content_text}>
          <h3>{recipe.name}</h3>
          <h5>{recipe.category}</h5>
        </div>

        <a
          href={`/recetas/${recipe.slug}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ zIndex: 1 }}
        >
          <Button text="Ver más" color={colorCategory} icon={WhiteArrowRight} />
        </a>
      </div>
    </div>
  );
};

export default RecipeCard;
